module.exports = __webpack_public_path__ + "img/Weapon_213.175f2035.png";